/**
 * Product Signature [New] — scroll reveals (Framer whileInView parity)
 * EASE: cubic-bezier(0.22, 1, 0.36, 1)
 *
 * data-ps-reveal
 * data-ps-reveal-x / data-ps-reveal-y  (px)
 * data-ps-reveal-dur                   (seconds)
 * data-ps-reveal-delay                 (ms)
 * data-ps-reveal-margin                (e.g. -120px)
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'product-signature-new';

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function applyVars(el) {
    var x = el.getAttribute('data-ps-reveal-x');
    var y = el.getAttribute('data-ps-reveal-y');
    var dur = el.getAttribute('data-ps-reveal-dur');
    var delay = el.getAttribute('data-ps-reveal-delay');
    if (x != null && x !== '') el.style.setProperty('--ps-x', x + 'px');
    if (y != null && y !== '') el.style.setProperty('--ps-y', y + 'px');
    if (dur != null && dur !== '') el.style.setProperty('--ps-dur', dur + 's');
    if (delay != null && delay !== '') el.style.setProperty('--ps-delay', delay + 'ms');
  }

  function positionPanel(panel, trigger) {
    var gap = 8;
    var margin = 12;
    var rect = trigger.getBoundingClientRect();
    var width = panel.offsetWidth;
    var height = panel.offsetHeight;
    var left = rect.left;
    var top = rect.bottom + gap;

    if (left + width > window.innerWidth - margin) {
      left = window.innerWidth - width - margin;
    }
    if (left < margin) left = margin;
    if (top + height > window.innerHeight - margin) {
      top = rect.top - height - gap;
    }
    if (top < margin) top = margin;

    panel.style.top = top + window.scrollY + 'px';
    panel.style.left = left + window.scrollX + 'px';
  }

  function initCtas(root) {
    var triggers = root.querySelectorAll('[data-ps-cta-trigger]');
    triggers.forEach(function (trigger) {
      if (trigger.dataset.vgPsCtaInit) return;
      trigger.dataset.vgPsCtaInit = '1';

      var panelId = trigger.getAttribute('aria-controls') || trigger.getAttribute('popovertarget');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      panel.addEventListener('beforetoggle', function (event) {
        if (event.newState === 'open') {
          panel.style.visibility = 'hidden';
        }
      });

      panel.addEventListener('toggle', function (event) {
        var open = event.newState === 'open';
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          positionPanel(panel, trigger);
          panel.style.visibility = '';
        }
      });

      window.addEventListener(
        'resize',
        function () {
          if (panel.matches(':popover-open')) positionPanel(panel, trigger);
        },
        { passive: true }
      );
    });
  }

  function init(root) {
    if (!root || root.dataset.vgPsInit) return;
    root.dataset.vgPsInit = '1';

    initCtas(root);

    var nodes = root.querySelectorAll('[data-ps-reveal]');
    if (!nodes.length) return;

    if (prefersReduced() || typeof IntersectionObserver === 'undefined') {
      nodes.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    nodes.forEach(applyVars);

    var groups = {};
    nodes.forEach(function (el) {
      var margin = el.getAttribute('data-ps-reveal-margin') || '-120px';
      if (!groups[margin]) groups[margin] = [];
      groups[margin].push(el);
    });

    Object.keys(groups).forEach(function (marginY) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-inview');
            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: marginY + ' 0px',
          threshold: 0,
        }
      );
      groups[marginY].forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root =
      evt.target &&
      (evt.target.querySelector
        ? evt.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]')
        : null);
    if (!root && evt.target && evt.target.matches) {
      root = evt.target.matches('[data-section-type="' + SECTION_TYPE + '"]') ? evt.target : null;
    }
    if (root) {
      delete root.dataset.vgPsInit;
      init(root);
    }
  });
})();
